module.exports = __webpack_public_path__ + "static/media/Max75stand.5c9ad44b.jpg";